export default __webpack_public_path__ + "static/media/login-img1.be89260f.png";